import verge from 'verge'

const breakpoints = {
  mobile: 768,
  tablet: 1023,
  desktop: 1215,
  widescreen: 1407
}

export default {
  getWidth: function () {
    return verge.viewportW()
  },
  isBetween: function (from, to) {
    const width = this.getWidth()
    return width > from && width <= to
  },
  isMobile: function () {
    return this.isBetween(0, breakpoints.mobile)
  },
  isTablet: function () {
    return this.isBetween(breakpoints.mobile, breakpoints.tablet)
  },
  isDesktop: function () {
    return this.isBetween(breakpoints.tablet, breakpoints.desktop)
  },
  isWidescreen: function () {
    return this.isBetween(breakpoints.desktop, breakpoints.widescreen)
  },
  isFullHD: function () {
    return this.getWidth() > breakpoints.widescreen
  },
  isTouch: function () {
    return this.getWidth() <= breakpoints.tablet
  },
  isTabletAndUp: function () {
    return this.getWidth() > breakpoints.mobile
  },
  isDesktopAndUp: function () {
    return this.getWidth() > breakpoints.tablet
  },
  isWidescreenAndUp: function () {
    return this.getWidth() > breakpoints.desktop
  }
}
